import LsCardSlide from './ls-card-slide'   //引入组件
const cardSlide = {
  // install: function(Vue) {
  //   Vue.component(VueComment.name, VueComment)
  // }
  install: function(Vue) {
  	if (typeof window !== 'undefined' && window.Vue) {
	  // Vue = window.Vue
	  window.Vue.use(cardSlide) 
	}
    Vue.component(LsCardSlide.name, LsCardSlide) //全局组件
  }
}

export default cardSlide  //导出


// WEBPACK FOOTER //
// ./src/lib/index.js